import { HomeBuyingStage, NextSteps } from "../../../../types/common";
import { FF2Step, FormData } from "../types";

export const handlePurchaseStep = (formData: FormData) => {
  let nextStep;

  // Turn away users borrowing less than our minimum
  const cleanedAmount = formData.borrowAmount!.replace(",", "");
  const borrowingAmount = parseInt(cleanedAmount, 10);
  if (borrowingAmount < MIN_MORTGAGE_AMOUNT) {
    return FF2Step.MortgageTooSmallPurchase;
  }

  switch (formData.homeBuyingStage) {
    case HomeBuyingStage.Accepted:
      nextStep = FF2Step.Signup;
      break;
    case HomeBuyingStage.Viewing:
    case HomeBuyingStage.Researching:
      switch (formData.nextSteps) {
        case NextSteps.Compare:
          nextStep = FF2Step.EmailToMortgageComparison;
          break;
        case NextSteps.Apply:
        case NextSteps.MIP:
        default:
          nextStep = FF2Step.Signup;
          break;
      }
      break;
    default:
      nextStep = FF2Step.Signup;
  }

  return nextStep;
};
